<template>
		<div class="tw-flex tw-flex-wrap tw--mx-2">
			<div v-for="(factor) in factorList" class="tw-w-1/3 lg:tw-w-1/4 xl:tw-w-1/5 tw-px-2 tw-mb-4">
				<factor-item-selectable
					:factor="factor"
					:key="factor.name"
					:selected="isSelected(factor)"
					@click="$emit('factorSelected', $event)"
				/>
			</div>
		</div>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import FactorItemSelectable
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/FactorItemSelectable';
import { factorIsSelected } from '@/modules/job-evaluation/utils/valuation-model/factors';

export default {
	name: 'ValuationModelFactorList',
	components: { FactorItemSelectable, Card },
	props: ['factorList', 'selectedFactors'],
	methods: {
		isSelected(factor) {
			return factorIsSelected(this.selectedFactors, factor);
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelFactorList.vue